module.exports = __webpack_public_path__ + "static/media/omega-logo.f309356a.png";